var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-dropdown',[_c('template',{slot:"title"},[_c('settings-dropdown-capitalized-column',{attrs:{"text":'',"is-editing":true,"can-edit":"","icon":"tags","color":"#0081F9"},on:{"cancel":function($event){return _vm.$emit('cancel-category')},"update-text":_vm.handleUpdateCategory}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }